import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    platformInfo: {},
    isLoggedIn: false,
    authUser: {},
    authChecked: false,
  },
  mutations: {
    getPlatformInfo(ext, info) {
      ext.platformInfo = info;
    },
    setAuth(state, user) {
      state.isLoggedIn = true;
      state.authUser = user || {};
    },
    clearAuth(state) {
      state.isLoggedIn = false;
      state.authUser = {};
    },
    setAuthChecked(state, checked) {
      state.authChecked = !!checked;
    },
  },
  actions: {},
  modules: {}
});